import { render, staticRenderFns } from "./FoodBeverageMobile.vue?vue&type=template&id=7a2db9f1&scoped=true&"
import script from "./FoodBeverageMobile.vue?vue&type=script&lang=js&"
export * from "./FoodBeverageMobile.vue?vue&type=script&lang=js&"
import style0 from "./FoodBeverageMobile.vue?vue&type=style&index=0&id=7a2db9f1&lang=scss&scoped=true&"
import style1 from "./FoodBeverageMobile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2db9f1",
  null
  
)

export default component.exports